import React from 'react';
import { Box } from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { C } from '../theme';

interface MediaPlaceholderProps {
  height?: number | string;
  icon?: React.ReactNode;
  label?: string;
}

/**
 * Branded fallback shown when an ad has no photo (or the photo fails to load),
 * instead of a broken <img> that leaks alt-text and leaves a blank gap.
 */
const MediaPlaceholder: React.FC<MediaPlaceholderProps> = ({ height = 280, icon, label = 'Nema slike' }) => (
  <Box
    aria-hidden
    sx={{
      width: '100%',
      height,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1.2,
      background: 'linear-gradient(135deg, #1E1E21 0%, #141416 60%, #0F0F11 100%)',
      color: C.muted,
      // faint gold sheen so it reads as "intentional", not "missing"
      boxShadow: 'inset 0 0 120px rgba(243,192,21,0.05)',
    }}
  >
    {icon || <ImageOutlinedIcon sx={{ fontSize: 56, color: 'rgba(243,192,21,0.45)' }} />}
    <Box component="span" sx={{ fontSize: '0.82rem', letterSpacing: '0.05em', color: C.muted }}>
      {label}
    </Box>
  </Box>
);

export default MediaPlaceholder;
